module.exports = __webpack_public_path__ + "img/dining-out.361abf95.png";